export enum EIntegrationUrls {
  CSV = 'csv',
  INTEGRATION = 'integration',
  PARTNER_API_INTEGRATIONS = 'partner-api-integrations',
  APPS = 'apps',
  CONNECTIONS = 'connections',
  PARTNERS = 'partners',
  WEBHOOK = 'webhook',
  SUBSCRIPTIONS = 'subscriptions',
  EVENT_TYPES = 'event-types',
  PREVIEW = 'preview',
  EXECUTE = 'execute',
  TEMPLATE = 'template',
  YARDI = 'yardi',
  PROPERTIES = 'properties',
  REFRESH = 'refresh',
  FREQUENCY = 'frequency',
  LINK = 'link',
  MISSING_STATES = 'missing-states',
  SYNC_STATE = 'sync-state',
  RESMAN = 'resman',
  SYNC = 'sync',
  CHARGE_SYNC_ENABLE = 'charge-sync-enable',
  VALIDATE = 'validate',
  TENANTS_PET_CHARGES = 'tenants-pet-charges',
  IMPORT = 'import',
  EXPORT = 'export',
  REAL_PAGE = 'real_page',
  APFOLIO = 'apfolio',
  SETTINGS = 'settings',
  TP = 'tp',
  CONNECT = 'connect',
  DISCONNECT = 'disconnect',
  UPLOAD = 'upload',
  ENABLE = 'enable',
  DISABLE = 'disable',
  COLLECT_TENANT_DETAILS = 'collect-tenant-details',
  ENTRATA = 'entrata',
}
